/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext } from 'react';

const ProtectedSessionContext = createContext(null);

export function ProtectedSessionProvider({ session, children }) {
  return (
    <ProtectedSessionContext.Provider value={session}>
      {children}
    </ProtectedSessionContext.Provider>
  );
}

export function useProtectedSession() {
  const session = useContext(ProtectedSessionContext);

  if (!session) {
    throw new Error('useProtectedSession must be used within ProtectedSessionProvider');
  }

  return session;
}
